import WPSResource from '../../../WPS.resource';
import { loadResourcesUtils } from '@ane/core/lib/utils/LoadResourcesUtils';
import { getDefaultAsyncWrapperObj } from '@ane/core/lib/models';
import { PROXY_STATUS_ACTION_KEYS, ROOT_REDUCER_KEYS } from '../../workspaceSettingsReducer';
export const defaultReducerState = getDefaultAsyncWrapperObj();
const workspaceProxyStatusGetPrefix = 'workspaceProxyStatusGet';
const workspaceProxyStatusGetEpicReducerArg = {
    actionPrefix: workspaceProxyStatusGetPrefix,
    reduxKeyNested: (inputPayload) => [
        ROOT_REDUCER_KEYS.PROXY_STATUS,
        PROXY_STATUS_ACTION_KEYS.GET,
    ],
    loadResource: (request) => WPSResource.getWorkspaceProxyStatus(request.workspaceId),
    onCompleteSuccess: (resourcesResult) => resourcesResult,
};
export const workspaceProxyStatusGetEpicReducer = loadResourcesUtils(workspaceProxyStatusGetEpicReducerArg);

//# sourceMappingURL=GetWorkspaceProxyStatus.ducks.js.map
